// extracted by mini-css-extract-plugin
module.exports = {"container":"ReviewCard_container__vZgN6","header":"ReviewCard_header__DNmsR"};